// Настройки PayKeeper
const PAYKEEPER_SERVER = 'https://duh-prim.paykeeper.ru'; // Замените на ваш сервер
const PAYMENT_ENABLED = true; // Включить/выключить оплату для тестов

export const createPayment = (orderData) => {
  if (!PAYMENT_ENABLED) {
    console.log('Оплата отключена для тестов. Данные заказа:', orderData);
    return false;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${PAYKEEPER_SERVER}/create/`;
  form.acceptCharset = 'utf-8';

  const fields = {
    sum: orderData.totalPrice,
    orderid: orderData.orderId,
    service_name: 'Заказ в Дух Приморья',
    client_email: orderData.customer.email || '',
    client_phone: orderData.customer.phone || '',
    cart: JSON.stringify(orderData.items.map(item => ({
      name: item.name,
      price: parseFloat(item.price.replace('₽', '')),
      quantity: item.quantity,
      sum: parseFloat(item.price.replace('₽', '')) * item.quantity,
      tax: 'none',
      item_type: 'commodity',
      payment_type: 'full_payment'
    })))
  };

  Object.keys(fields).forEach(key => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = fields[key];
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  return true;
};

export const isPaymentEnabled = () => PAYMENT_ENABLED;
